import { render, staticRenderFns } from "./UnrelatedOrganisationRelations.vue?vue&type=template&id=5780afe8"
import script from "./UnrelatedOrganisationRelations.vue?vue&type=script&lang=js"
export * from "./UnrelatedOrganisationRelations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports